import { render, staticRenderFns } from "./batchDeliver.vue?vue&type=template&id=5b254c1c&scoped=true"
import script from "./batchDeliver.vue?vue&type=script&lang=js"
export * from "./batchDeliver.vue?vue&type=script&lang=js"
import style0 from "./batchDeliver.vue?vue&type=style&index=0&id=5b254c1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b254c1c",
  null
  
)

export default component.exports